module.exports = __webpack_public_path__ + "static/media/ad3.8611fae1.png";